import React from 'react'

interface PryLogoProps {
    className?: string
}

export default function PryLogo({ className = '' }: PryLogoProps) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 32" fill="none">
            <g clipPath="url(#clip0)">
                <path
                    className="dark:fill-white fill-[#F4C222]"
                    d="M6.712 13.5119C8.04245 13.5132 9.34311 13.1181 10.448 12.3769C11.5552 11.6339 12.4175 10.5796 12.926 9.34694C13.435 8.11264 13.5689 6.75566 13.3108 5.4457C13.0527 4.13573 12.4142 2.93092 11.475 1.98194C10.5387 1.03611 9.34153 0.391162 8.03662 0.129645C6.7317 -0.131873 5.37843 0.00193387 4.15 0.51394C2.91981 1.0261 1.86942 1.89203 1.132 3.00194C0.268078 4.30205 -0.120917 5.86037 0.0306539 7.41397C0.182225 8.96757 0.865081 10.4213 1.964 11.5299C2.58572 12.1567 3.32513 12.6544 4.13977 12.9945C4.9544 13.3347 5.82821 13.5105 6.711 13.5119H6.712Z"
                />
                <path className="dark:fill-white fill-[#5C5CE5]" d="M14.896 23.0759V14.9839L22.946 23.0759H14.896Z" />
                <path
                    className="dark:fill-white fill-[#E54C4C]"
                    d="M22.946 6.89806L6.854 23.0761H0L22.946 0.00805664V6.89806Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M38.054 0.00805664H40.989C43.0264 0.0277316 44.9741 0.849407 46.41 2.29506C47.8507 3.74507 48.6672 5.70106 48.685 7.74506C48.6796 9.77383 47.8748 11.7187 46.445 13.1581C45.0197 14.5933 43.0827 15.4037 41.06 15.4111H36.795V23.0761H32.175V0.00805664H36.795V10.8381H40.989C41.805 10.8381 42.588 10.5121 43.165 9.93206C43.7428 9.35085 44.0671 8.5646 44.0671 7.74506C44.0671 6.92551 43.7428 6.13926 43.165 5.55806C42.8799 5.27109 42.5409 5.04331 42.1674 4.88783C41.794 4.73234 41.3935 4.65221 40.989 4.65206H36.795L38.054 0.00805664ZM49.802 23.0761H54.422V6.62206H49.802V23.0761ZM64.911 6.62206L69.521 23.0611L74.141 6.62106H78.689L71.607 32.0001H67.012L69.522 23.0761H64.91L60.29 6.62206L59.016 11.1861H54.42L55.742 6.62206H64.91H64.911Z"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="79" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
